// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2hZcM","spin":"Loader_spin__1X-nh","screen":"Loader_screen__31_OK","blocker":"Loader_blocker__hrElH","blockerLoader":"Loader_blockerLoader__dEkNN"};